import styled from 'styled-components';

export const CardHeader = styled.div`
    padding: var(--space-lg);
    background: var(--container-background-color-300);
`;
